class VenturzInterfaces {

  constructor(basePath, apiClient) {

    this.basePath = basePath;
    this.apiClient = apiClient;

  }

  getStartupsByQueryOptions(queryOptions) {

    return this.apiClient.get(`${this.basePath}/startups`, {}, queryOptions);

  }

  getBlockedStartups(projection) {

    return this.apiClient.get(`${this.basePath}/blocked-startups`, {}, { projection });

  }

  blockStartups(startupIds) {

    return this.apiClient.post(`${this.basePath}/blocked-startups`, {}, {}, startupIds);

  }

  unblockStartups(unblockedStartupId) {

    return this.apiClient.delete(`${this.basePath}/blocked-startups/:unblockedStartupId`, { unblockedStartupId }, {});

  }

  getMasterPromptVersions() {

    return this.apiClient.get(`${this.basePath}/assistant-master-prompt/versions`, {}, {});

  }

  getMasterPrompt() {

    return this.apiClient.get(`${this.basePath}/assistant-master-prompt`, {}, {});

  }

  setMasterPrompt(value) {

    return this.apiClient.put(`${this.basePath}/assistant-master-prompt`, {}, {}, { value });

  }

  getAlwaysOnAIPlatformInstructions() {

    return this.apiClient.get(`${this.basePath}/always-on-ai/instructions`, {}, {}, {});

  }

  getAlwaysOnAIPlatformInstructionVersions() {

    return this.apiClient.get(`${this.basePath}/always-on-ai/instructions/versions`, {}, {}, {});

  }

  updateAlwaysOnAIPlatformInstructions(data) {

    return this.apiClient.put(`${this.basePath}/always-on-ai/instructions`, {}, {}, data);

  }

}

export default VenturzInterfaces;